import {
  literalParamWithDefault,
  optionalLiteralParam,
  optionalStringParam,
  parseableSearchSchema,
} from "@crm/effect/schema/search";
import { Schema } from "effect";

export const sessionDetailSearchSchema = parseableSearchSchema(
  Schema.Struct({
    // Tab 切换：固定默认值 "students"
    tab: literalParamWithDefault(
      [
        "students",
        "sites",
        "inquiry-proofs",
        "content-topics",
        "groups",
        "feedback-completion",
        "in-class-tasks",
        "media",
        "resources",
        "leaderboard",
      ],
      "students",
    ),

    // 学员列表筛选：可选字段
    q: optionalStringParam(),
    staff: optionalStringParam(),
    status: optionalLiteralParam("all", "registered", "in_class", "finished", "dropout"),

    // 反馈天数筛选：可选字段
    feedbackDay: optionalLiteralParam("all", "0", "1", "2", "3", "missing"),
  }),
);

export type SessionDetailSearch = Schema.Schema.Type<typeof sessionDetailSearchSchema>;
